<template>
	<div class="pubheader">
		<div class="title">
			<div class="fixation">
				<div class="left">
					尊敬的客户您好，欢迎来到{{$store.state.websiteConfig.company_name}}！
				</div>
				<div class="right">
					<div class="item" @click="openLogin" v-if="!loginFlag">
						<i class="el-icon-user"></i>
						<span>请登录</span>
					</div>
					<div class="item" v-else>
						<router-link to="/space">
							<i class="el-icon-user"></i>
							[ {{$store.state.userinfo.username}} ]
						</router-link>
					</div>
					<div class="item" @click="doLogout" v-if="loginFlag">
						<span>退出登录</span>
					</div>
					<div class="item">
						<i class="el-icon-phone-outline"></i>
						<span>
							{{$store.state.websiteConfig.contact[0]['value']}}
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="logo-search">
			<div class="fixation">
				<div class="logo">
					<router-link to="/index">
						<img src="../../../assets/index-logo.png" alt="">
					</router-link>
					<img src="../../../assets/index-logo-2.png" alt="">
				</div>
				<div class="search" v-if="[4,5].indexOf(current)<0">
					<div class="search-icon">
						<i class="el-icon-search"></i>
					</div>
					<div class="search-input">
						<!-- <input type="text" v-model="keyword" placeholder="请输入标的物名称/送拍机构/拍卖特场邀请码"> -->
						<input type="text" v-model="keyword" placeholder="请输入标的物名称" @keydown.enter="keydown">
					</div>
					<div class="search-button">
						<button @click="doSearch">搜索</button>
					</div>
				</div>
			</div>
		</div>
		<div class="menu">
			<div class="fixation">
				<div class="navigate">
					<div class="navigate-item" v-if="current == 0">
						<router-link :class="current == 0 ? 'current' : ''" to="/index">
							首页
						</router-link>
					</div>
					<div class="navigate-item" v-else>
						<router-link to="/index">
							全部分类
						</router-link>
					</div>
					<div class="navigate-item" v-for="(item,index) in navigate" :key="index">
						<router-link :class="current == index + 1 ? 'current' : ''" :to="{path:item.path}">
							{{item.name}}
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'pubheader',
		props: ['current'],
		data() {
			return {
				phone: '',
				navigate: [{
						name: '公益拍卖',
						path: '/one'
					},
					{
						name: '拍卖预告',
						path: '/advance'
					},
					{
						name: '拍卖现场',
						path: '/scene'
					},
					{
						name: '拍卖指南',
						path: '/guide'
					},
					{
						name: '法规·资讯',
						path: '/paper'
					},
					{
						name: '关于我们',
						path: '/about'
					}
				],
				keyword: '',
				loginFlag: false,
				userinfo: {
					name: ''
				}
			};
		},
		computed: {
			loginStatus() {
				return this.$store.state.hasLogin
			}
		},
		watch: {
			loginStatus(flag) {
				this.loginFlag = flag
			}
		},
		methods: {
			...mapMutations(['logout']),
			openLogin() {
				this.$emit('openLogin')
			},
			doLogout() {
				this.$confirm('请问是否确认退出登录？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					distinguishCancelAndClose: true,
					closeOnClickModal: false
				}).then(() => {
					this.$message({
						type: 'success',
						message: '退出登录成功',
						duration: 1500,
						onClose: () => {
							this.logout()
						}
					});
				}).catch(() => {});
			},
			keydown(event) {
				this.doSearch()
			},
			doSearch() {
				this.$store.state.auctionKeyword = this.keyword
				if (this.$router.path != '/result') {
					this.$router.push({
						path: '/result'
					})
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.loginFlag = this.$store.state.hasLogin
			this.userinfo = this.$store.state.userinfo
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.pubheader {
		width: 100%;

		.title {
			width: 100%;
			height: 36px;
			background: @vue-bg-color-grey;

			.fixation {
				display: flex;
				justify-content: space-between;

				.left {
					height: 100%;
					display: flex;
					align-items: center;
					font-size: @vue-font-size-sm - 2;
				}

				.right {
					height: 100%;
					display: flex;
					align-items: center;

					.item {
						padding-left: @vue-spacing-row-base;
						display: flex;
						font-size: @vue-font-size-sm - 2;
						cursor: pointer;

						i {
							margin-right: @vue-spacing-row-sm / 2;
							margin-top: 3px;
						}

						span {
							color: @vue-text-color-red;
						}

						a {
							color: @vue-text-color-red;
						}
					}

					.item:first-child {
						border-right: 1px solid @vue-border-color;
						padding-right: @vue-spacing-row-base;
						cursor: pointer;
					}
				}
			}
		}

		.logo-search {
			width: 100%;
			height: 120px;

			.fixation {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.logo {
					display: flex;
					align-items: center;
				}

				.search {
					width: 590px;
					height: 40px;
					display: flex;
					justify-content: space-between;
					border: 2px solid @vue-border-color-red;
					box-sizing: border-box;

					.search-icon {
						width: 40px;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
					}

					.search-input {
						width: calc(100% - 160px);
						height: 100%;

						input {
							width: 100%;
							height: 100%;
							display: block;
							border: none;
							outline: none;
						}
					}

					.search-button {
						width: 120px;
						height: 100%;

						button {
							width: 100%;
							height: 100%;
							background: @vue-bg-color-red;
							color: @vue-text-color-inverse;
							border: none;
						}
					}
				}
			}
		}

		.menu {
			width: 100%;
			height: 60px;
			border-bottom: 2px solid @vue-border-color-red;
			box-sizing: border-box;

			.navigate {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;

				.navigate-item {
					width: 125px;

					a {
						width: 100%;
						height: 32px;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: @vue-font-size-sm - 2;
						color: @vue-text-color;
					}

					a:hover {
						background: @vue-bg-color-red;
						color: @vue-text-color-inverse;
						border-radius: 16px;
					}

					.current {
						background: @vue-bg-color-red;
						color: @vue-text-color-inverse;
						border-radius: 16px;
					}
				}
			}
		}
	}
</style>
